import { render, staticRenderFns } from "./UnosOdsustva.vue?vue&type=template&id=0660adaf&scoped=true&"
import script from "./UnosOdsustva.vue?vue&type=script&lang=ts&"
export * from "./UnosOdsustva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0660adaf",
  null
  
)

export default component.exports